var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTickwhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 23,
    viewBox: "0 0 25 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 7.50049L6.25 9.25049L12.5 15.5005L25 3.00049L23.25 1.25049L12.5 12.0005L8 7.50049Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.25 20C6.375 20 2.5 16.125 2.5 11.25C2.5 6.375 6.375 2.5 11.25 2.5C12.75 2.5 14.25 2.875 15.625 3.625L16.875 1.5C15.125 0.5 13.25 0 11.25 0C5 0 0 5 0 11.25C0 17.5 5 22.5 11.25 22.5C17.5 22.5 22.5 17.5 22.5 11.25H20C20 16.125 16.125 20 11.25 20Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTickwhite);
export default __webpack_public_path__ + "static/media/tickwhite.9bbf4b337de8f143b45111fc65bba8f6.svg";
export { ForwardRef as ReactComponent };